<template>
    <div>
        <!-- Header -->
        <div class="tw:mb-6" data-testid="enviar-entradas-header">
            <h3 class="tw:text-xl tw:font-bold tw:text-slate-900 tw:m-0">{{ $t('perfil.enviar_entradas') }}</h3>
            <p v-if="pedido" class="tw:text-sm tw:text-slate-500 tw:m-0 tw:mt-1">{{ pedido.evento?.nombre }}</p>
            <p v-if="pedido?.sesion" class="tw:text-xs tw:text-slate-400 tw:m-0 tw:mt-0.5">{{ pedido.sesion.fecha }}</p>
        </div>

        <CardFront>
            <!-- Select all row -->
            <div class="tw:flex tw:justify-between tw:gap-3 tw:pb-3 tw:border-b tw:border-slate-100 tw:mb-3" data-testid="enviar-entradas-select-all-row">
                <ToggleSwitch
                    :value="isAllSelected"
                    @input="emit('toggle-all')"
                    id="select-all-envio"
                    size="sm"
                    variant="alt"
                >
                    {{ $t('perfil.cambio_datos.seleccionar_todas') }}
                </ToggleSwitch>
                <span class="tw:text-slate-500 tw:text-sm" data-testid="enviar-entradas-selected-count">
                    {{ seleccionadas.length }} / {{ pedido?.entradas?.length || 0 }}
                </span>
            </div>

            <!-- Entradas list -->
            <div class="tw:space-y-2" data-testid="enviar-entradas-list">
                <div
                    v-for="entrada in pedido?.entradas || []"
                    :key="entrada.id"
                    :data-testid="`enviar-entradas-row-${entrada.id}`"
                    class="tw:flex tw:items-center tw:gap-3 tw:p-3 tw:rounded-xl tw:border tw:transition-colors"
                    :class="{ 'tw:bg-red-50 tw:border-red-200': isSelectedFn(entrada), 'tw:border-slate-100 tw:hover:bg-slate-50': !isSelectedFn(entrada) }"
                >
                    <ToggleSwitch
                        :value="isSelectedFn(entrada)"
                        :id="`entrada-toggle-${entrada.id}`"
                        @input="emit('toggle-entrada', entrada)"
                        size="sm"
                        variant="alt"
                    />
                    <div class="tw:flex tw:justify-between tw:gap-12 tw:min-w-0">
                        <div>
                            <p class="tw:text-[10px] tw:font-bold tw:text-slate-400 tw:uppercase tw:m-0">{{ $t('perfil.entrada_detalle.titular') }}</p>
                            <p class="tw:text-sm tw:text-slate-900 tw:m-0 tw:normal-case">
                                {{ entrada.user_nombre || '-' }} <span>{{ entrada.user_apellidos }}</span>
                            </p>
                            <p class="tw:text-xs tw:text-slate-500 tw:font-mono tw:m-0">{{ entrada.user_dni || '-' }}</p>
                        </div>
                        <div>
                            <p class="tw:text-[10px] tw:font-bold tw:text-slate-400 tw:uppercase tw:m-0">{{ $t('perfil.entrada_detalle.ubicacion') }}</p>
                            <p class="tw:text-sm tw:text-slate-900 tw:m-0 tw:normal-case">{{ getUbicacion(entrada).zona }}</p>
                            <p class="tw:text-[10px] tw:text-slate-500 tw:font-bold tw:m-0">
                                {{ $t('perfil.entrada_detalle.fila_asiento', { fila: getUbicacion(entrada).fila, asiento: getUbicacion(entrada).asiento }) }}
                            </p>
                        </div>
                        <div>
                            <p class="tw:text-[10px] tw:font-bold tw:text-slate-400 tw:uppercase tw:m-0 tw:mb-1">{{ $t('perfil.estado') }}</p>
                            <BadgeFront
                                v-if="entrada.enviado?.email"
                                :label="$t('perfil.enviada')"
                                variant="alt"
                            />
                            <BadgeFront
                                v-else
                                :label="$t('perfil.no_enviada')"
                                variant="default"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </CardFront>
    </div>
</template>

<script setup>
    import CardFront from '@/modules/front/ui/CardFront.vue';
    import BadgeFront from '@/modules/front/ui/BadgeFront.vue';
    import ToggleSwitch from '@/modules/front/ui/ToggleSwitch.vue';
    import { getUbicacion } from '@/composables/front/perfil/useUbicacionEntrada';

    const props = defineProps({
        pedido:        { type: Object,  default: null },
        seleccionadas: { type: Array,  default: () => [] },
        isAllSelected: { type: Boolean, default: false },
        isSomeSelected: { type: Boolean, default: false },
    });

    const emit = defineEmits(['toggle-entrada', 'toggle-all']);

    const isSelectedFn = entrada => props.seleccionadas.some(s => s.id === entrada.id);
</script>
